import React from 'react';

const SectionTitle = ({ title }) => {
  return (
    <div className='section-title'>
      <h3 id='sub-title'>{title}</h3>
    </div>
  );
};

export default SectionTitle;
